import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "templateSettings" }
const _hoisted_2 = /*#__PURE__*/_createVNode("option", { value: true }, "Number", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("option", { value: false }, "Text", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, "#", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "=", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Add variable", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("i", null, "#variableName"),
  /*#__PURE__*/_createTextVNode(" in any text-input within this template to use the corresponding variable. You can also use them in actions. Make sure that each variable is actually assined a value. In number-inputs you can press '#' to activate text-input (only avalable for some inputs). ")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.defaultData, (data, i) => {
      return (_openBlock(), _createBlock("div", {
        key: i,
        class: "settings-row"
      }, [
        _createVNode("select", {
          value: typeof data.value == 'number',
          onChange: $event => (
          $event.target.value == 'true'
            ? (data.value = 123)
            : (data.value = 'value')
        )
        }, [
          _hoisted_2,
          _hoisted_3
        ], 40, ["value", "onChange"]),
        _hoisted_4,
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": $event => (data.name = $event)
        }, null, 8, ["onUpdate:modelValue"]), [
          [_vModelText, data.name]
        ]),
        _hoisted_5,
        (typeof data.value == 'number')
          ? _withDirectives((_openBlock(), _createBlock("input", {
              key: 0,
              type: "number",
              "onUpdate:modelValue": $event => (data.value = $event)
            }, null, 8, ["onUpdate:modelValue"])), [
              [
                _vModelText,
                data.value,
                void 0,
                { number: true }
              ]
            ])
          : _withDirectives((_openBlock(), _createBlock("input", {
              key: 1,
              type: "text",
              "onUpdate:modelValue": $event => (data.value = $event)
            }, null, 8, ["onUpdate:modelValue"])), [
              [_vModelText, data.value]
            ]),
        _createVNode("span", {
          class: "material-icons closeIcon",
          onClick: $event => (_ctx.component.defaultData.splice(i, 1))
        }, "close", 8, ["onClick"])
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode("div", {
      class: "btn",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.component.defaultData.push({ name: 'varName', value: 'value' })))
    }, [
      _hoisted_6,
      _hoisted_7
    ]),
    _hoisted_8
  ]))
}